  /*
  	Automatic discount generation based on 4 for £10
  */
const generateDiscount = () =>
{
    jQuery.getJSON('/cart.js', function(cart) 
    {
        let discountCode = '';
        let numberOfElegibleProducts = 0;
        cart.items.forEach(item => {
          if (item.product_type != undefined){
            let searchRegexp = /vape/gmi;
            let productType = item.product_type;
            if (productType.search(searchRegexp) != -1){
              numberOfElegibleProducts+= item.quantity;
            }
          }
        })
        if (numberOfElegibleProducts < 5){
            discountCode = '';
            //console.log(discountCode);
        }
        else if(numberOfElegibleProducts > 100){
            discountCode = '1004300';
            //console.log(discountCode);
        }
        else{
          let numberOfDiscounts = Math.floor(numberOfElegibleProducts / 5);
      
          if (numberOfDiscounts > 0)
          {
              /*
                  CONVERT INTO DISCOUNT CODE
                  NUMBER OF DISCOUNTS IS TOTAL PRODUCTS IN CART / 5
                  DISCOUNT CODE IS FORMATTED AS (NUMBEROFCARDS) '4' (PRICE) 
                  E.G 5419 (5 VAPES FOR 19 POUNDS)
              */

              discountCode = `${numberOfDiscounts * 5}4${numberOfDiscounts * 19}`;
              //console.log(discountCode);
          }
          
        }
      
        console.log(discountCode);
        if (discountCode != ''){
            let currentAction = $('#shopify-section-cart-template form').attr('action'); 
          
            const regex = /\?discount=[0-9]{3,}/;
          
            let newAction = '';

            if (currentAction.search(regex) != -1)
            {
                newAction = currentAction.replace(regex, `?discount=${discountCode}`);
              
                $('#shopify-section-cart-template form').attr('action', newAction);
            }
            else
            {
                $('#shopify-section-cart-template form').attr('action', currentAction + '?discount=' + discountCode);
            }
            let discountCodeButton =  document.querySelector('[data-copy-discount]');
            let discountCodeSpan = document.querySelector('[data-discount-code]');
            discountCodeSpan.innerText = discountCode;
            discountCodeButton.style.display = 'block';
            discountCodeButton.addEventListener('click', e => {
              e.preventDefault();
              navigator.clipboard.writeText(discountCode);
              discountCodeButton.innerText = 'Discount Code Copied!'
            })
        } else 
        {
            $('#shopify-section-cart-template form').attr('action', '/cart');
        }
    });
};
  
$(document).ready(function()
{
    generateDiscount();

});